// Google reCAPTCHA v3 helper. Dormant (returns "") when no site key is set,
// so the checkout keeps working until the key is configured.
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let scriptPromise = null;

function loadScript() {
  if (!SITE_KEY) return Promise.resolve(false);
  if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
    s.async = true;
    s.defer = true;
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.head.appendChild(s);
  });
  return scriptPromise;
}

// Preload the script early so the token is ready at pay time.
export function initRecaptcha() {
  if (SITE_KEY) loadScript();
}

// Returns a v3 token for the given action, or "" when not configured/unavailable.
export async function getRecaptchaToken(action = "payment") {
  if (!SITE_KEY) return "";
  const ok = await loadScript();
  if (!ok || !window.grecaptcha) return "";
  try {
    await new Promise((res) => window.grecaptcha.ready(res));
    return await window.grecaptcha.execute(SITE_KEY, { action });
  } catch {
    return "";
  }
}
